import { useState, useEffect } from 'react';
import api from '../utils/axios';
import { API_ENDPOINTS } from '../config/api';

// Custom hook to fetch and manage dynamic form fields
export const useFormFields = () => {
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFields = async () => {
    try {
      setLoading(true);
      const response = await api.get(API_ENDPOINTS.FORM_FIELDS);
      const data = response.data;

      if (data.success) {
        setFields(data.fields);
        setError(null);
      } else {
        setError('Failed to fetch form fields');
      }
    } catch (err) {
      console.error('Error fetching form fields:', err);
      setError('Error loading form fields');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFields();
  }, []);

  return { fields, loading, error, refetch: fetchFields };
};

export default useFormFields;
